<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="报废详情"
      width="600px"
      class="scrapEdit"
      top="30vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        class="form"
        :model="materialInfo"
        :rules="ruleValidate"
        label-width="80px">
      <el-row style="margin-top:1vh;">
        <el-col :span="24">
          <el-form-item label="物料名称:">
            <el-input v-model="materialInfo.materialName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="物料编号:">
            <el-input v-model="materialInfo.materialNo" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="报废数量:">
            <el-input v-model="amount" type="number" placeholder="请输入数量"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit"> 确定 </el-button>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    name: "ScrapEdit",
    data() {
      return {
        dialogVisible:false,
        submitLoading:false,
        amount:0,
        materialInfo:[],
        materialName:"",
        ruleValidate:{},
      };
    },
    methods:{
      open(info) {
        this.dialogVisible = true;
        this.materialInfo = info;
      },
      handleSubmit() {
        let materialInfo = {
          workCenterId: this.materialInfo.workCenterId,
          workCenterNo: this.materialInfo.workCenterNo,
          workCenterName: this.materialInfo.workCenterName,
          materialId: this.materialInfo.materialId,
          materialNo: this.materialInfo.materialNo,
          materialName: this.materialInfo.materialName,
          materialSn: this.materialInfo.materialSn,
          materialHeight: this.materialInfo.materialHeight,
          materialWidth: this.materialInfo.materialWidth,
          materialLength: this.materialInfo.materialLength,
          materialWeight: this.materialInfo.materialWeight,
          specification: this.materialInfo.specification,
          locationId: this.materialInfo.locationId,
          locationNo: this.materialInfo.locationNo,
          locationName: this.materialInfo.locationName,
          quantity: this.materialInfo.quantity ,
          scrapQuantity: parseInt(this.amount),
          price: this.materialInfo.price,
          unitId: this.materialInfo.unitId,
          unitName: this.materialInfo.unitName,
        };
        console.log(materialInfo);
        console.log(this.amount <= 0);
        if(this.amount <= 0) {
          this.$message.error("数量有误！请重新输入！");
        }else{
          this.$http.post("basic","workCenters/location/materialScrap",materialInfo).then((resp)=>{
            if(resp.success) {
              this.$emit("save-success");
              this.$message.success("操作成功！");
              this.dialogVisible = false;
            }
          }).catch(()=>{
            this.$message.error("操作失败！");
            this.dialogVisible = false;
          });
        } 
      },
    },
  };
</script>
<style>
.scrapEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.scrapEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.scrapEdit .el-dialog {
  margin: 6% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 30%;
}

.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.scrapEdit .el-divider--horizontal {
  margin: 10px 0;
}

.scrapEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>